import React, { useState, useEffect } from "react";
import { useDispatch, useSelector } from "react-redux";
import {
  Alert,
  Button,
  ButtonGroup,
  Card,
  Col,
  Form,
  Row,
  Spinner,
  Dropdown,
  Tooltip,
  OverlayTrigger,
} from "react-bootstrap";
import { getRecidivismActionsDisciplinarias } from "../../../../redux/Modulo_Sanciones/Recidivism/actions";
import { getStatuss } from "../../../../redux/Modulo_Sanciones/status/actions";
import CustomTable from "../../../../components/CustomTable";
import CustomPagint from "../../../../components/CustomPagint";
import { BsPerson } from "react-icons/bs";
import { BsClockHistory } from "react-icons/bs";
import { BsChevronDoubleRight } from "react-icons/bs";
import ReincidenciasAccionesEmployee from "./ReincidenciasAccionesEmployee";

const filters = [
  { id: "empleado__codigo", desc: "Código de empleado" },
  { id: "empleado", desc: "Nombre de empleado" },
  { id: "estatus", desc: "Estatus" },
];
function ReincidenciasAcciones({ toggleButtonsVisibility }) {
  const [offset, setOffset] = useState(0);
  const [limit, setLimit] = useState(10);
  const [currentPage, setCurrentPage] = useState(1);
  const [filter, setFilter] = useState("");
  const [tipoBusqueda, setTipoBusqueda] = useState(filters[0]);
  const [showComponent, setShowComponent] = useState(false);
  const [selectedEmployeeCode, setSelectedEmployeeCode] = useState(null);
  const [selectedEmployeeName, setSelectedEmployeeName] = useState(null);
  const [statusColors, setStatusColors] = useState([]);
  const [view, setView] = useState("");

  const dispatch = useDispatch();
  const userRoles = useSelector((store) => store.auth.userRoles);
  const { loading, recidivismActionsDisciplinarias, recidivismActionsError } =
    useSelector((store) => store.recidivismActions);
  const { statuss } = useSelector((store) => store.sancionesStatus);

  // Arreglo de reincidencias
  const data = Array.isArray(recidivismActionsDisciplinarias)
    ? recidivismActionsDisciplinarias
    : recidivismActionsDisciplinarias?.data || [];

  // Cantidad de paginas disponibles
  const pages = Math.ceil(
    (recidivismActionsDisciplinarias
      ? recidivismActionsDisciplinarias.count
      : 0) / limit
  );

  // Función para obtener los casos de reincidencias
  const _getRecidivismActions = (
    offs = offset,
    lim = limit,
    tipo = tipoBusqueda.id,
    filt = filter,
    viw = view
  ) =>
    dispatch(
      getRecidivismActionsDisciplinarias({
        offset: offs,
        limit: lim,
        tipo_busqueda: tipo,
        filter: filt,
        vista: viw,
      })
    );

  // Efecto para cargar los casos de reincidencias al montar el componente
  useEffect(() => {
    if (userRoles.length > 0) {
      const rolActual = userRoles.filter(
        (usr) =>
          usr === "jefe" ||
          usr === "administrador" ||
          usr === "Responsable_Sanciones" ||
          usr === "Encargado_Sanciones" ||
          usr === "alta_direccion"
      )[0];
      setView(rolActual);

      // Verifica si ya se han cargado los estados
      if (!statuss || statuss.length === 0) {
        dispatch(getStatuss());
      }

      _getRecidivismActions(offset, limit, tipoBusqueda.id, filter, rolActual);
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [dispatch, offset, limit, userRoles]);

  // Función para paginación (modificada para actualizar el offset correctamente)
  const handlePagination = (newOffset) => {
    setOffset(newOffset);
    setCurrentPage(Math.ceil(newOffset / limit) + 1);
  };

  // Función para manejar la búsqueda
  const onSearch = (e) => {
    e.preventDefault();
    const searchValue = e.target.filter.value;
    setFilter(searchValue);
    const oOffset = 0;
    setOffset(oOffset);
    setCurrentPage(1);
    _getRecidivismActions(oOffset, limit, tipoBusqueda.id, searchValue);
  };

  // Función para ver todos los registros
  const seeAll = () => {
    const oSearch = "";
    setFilter(oSearch);
    const oOffset = 0;
    setOffset(oOffset);
    setCurrentPage(1);
    _getRecidivismActions(oOffset, limit, tipoBusqueda.id, oSearch);
  };

  // Efecto para actualizar los colores de los estados cuando se obtienen los datos
  useEffect(() => {
    if (statuss && statuss.data) {
      setStatusColors(statuss.data); // Almacenar los estados y colores en el estado
    }
  }, [statuss]);

  // Función para obtener el color correspondiente al estado
  const getColorByStatus = (status) => {
    const statusInfo = statusColors.find((item) => item.nombre === status);
    return statusInfo ? statusInfo.color_a_mostrar : "#000000"; // Color por defecto si no se encuentra
  };

  // Columnas de la tabla
  const columns = [
    {
      Header: "",
      accessor: "icono_usuario",
      Filter: "",
      Cell: () => <BsPerson size={20} />,
    },
    {
      Header: "Código de empleado",
      accessor: "caso_disciplinario__codigo_empleado__codigo",
      Filter: "",
    },
    {
      Header: "Nombre de empleado",
      accessor: "caso_disciplinario__codigo_empleado__nombre",
      Filter: "",
    },
    {
      Header: "Cantidad de casos",
      accessor: "cantidad_acciones",
      Filter: "",
    },
    {
      Header: "Estatus",
      accessor: "status",
      Filter: "",
      Cell: ({ value }) => (
        <div
          className="p-2 rounded-pill text-white text-center"
          style={{
            backgroundColor: getColorByStatus(value),
          }}
        >
          {value}
        </div>
      ),
    },
    {
      Header: "Acciones",
      accessor: "acciones",
      Filter: "",
      Cell: (value) => (
        <Button
          variant="link"
          size="sm"
          onClick={() => {
            setSelectedEmployeeCode(
              value.row.original.caso_disciplinario__codigo_empleado__codigo
            );
            setSelectedEmployeeName(
              value.row.original.caso_disciplinario__codigo_empleado__nombre
            );
            setShowComponent(true);
            toggleButtonsVisibility();
          }}
        >
          <BsChevronDoubleRight size={20} />
        </Button>
      ),
    },
  ];

  // Contenido inicial
  const renderInitialContent = (props) => {
    const statusOptions = statuss?.data?.map((status) => status.nombre) || [];

    return (
      <div>
        <div className="my-1 d-flex flex-wrap justify-content-between align-items-center">
          <h6>
            <BsClockHistory className="me-2" />
            Historial de Acciones
          </h6>
          <Form onSubmit={onSearch}>
            <Row className="justify-content-end align-items-center flex-nowrap">
              <Col>
                <p>
                  <b>Búsqueda por: </b>
                  {tipoBusqueda.desc}
                </p>
              </Col>
              <Col xs="auto">
                {tipoBusqueda.id === "estatus" ? (
                  <Dropdown>
                    <Dropdown.Toggle variant="light" className="rounded-pill">
                      {filter || "Seleccionar estatus"}
                    </Dropdown.Toggle>
                    <Dropdown.Menu>
                      {statusOptions.map((status) => (
                        <Dropdown.Item
                          key={status}
                          onClick={() => {
                            setFilter(status);
                            const oOffset = 0;
                            setOffset(oOffset);
                            setCurrentPage(1);
                            _getRecidivismActions(
                              oOffset,
                              limit,
                              tipoBusqueda.id,
                              status
                            );
                          }}
                        >
                          {status}
                        </Dropdown.Item>
                      ))}
                    </Dropdown.Menu>
                  </Dropdown>
                ) : (
                  <Form.Control
                    name="filter"
                    id="filter"
                    placeholder="Buscar"
                    className="rounded-pill form-control-sm"
                    type="search"
                  />
                )}
              </Col>
              <Col xs="auto">
                <ButtonGroup>
                  <Button
                    onClick={() => seeAll()}
                    variant="light"
                    size="sm"
                    className="rounded-circle"
                  >
                    <i className="material-icons">list</i>
                  </Button>
                  <ButtonGroup>
                    <OverlayTrigger
                      placement="auto"
                      overlay={
                        <Tooltip {...props}>Seleccionar Filtrado</Tooltip>
                      }
                    >
                      <Dropdown className="ml-3 mr-3">
                        <Dropdown.Toggle
                          variant="light"
                          className="btn-sm font rounded-pill"
                        >
                          <i className="material-icons">filter_list</i>
                        </Dropdown.Toggle>
                        <Dropdown.Menu>
                          {filters.map((item) => (
                            <Dropdown.Item
                              onClick={() => {
                                setTipoBusqueda(item);
                                setFilter("");
                              }}
                              key={item.id}
                            >
                              {item.desc}
                            </Dropdown.Item>
                          ))}
                        </Dropdown.Menu>
                      </Dropdown>
                    </OverlayTrigger>
                  </ButtonGroup>
                </ButtonGroup>
              </Col>
            </Row>
          </Form>
        </div>
        {recidivismActionsError && (
          <Alert variant="danger" className="my-4">
            {recidivismActionsError}
          </Alert>
        )}
        {loading ? (
          <div className="d-flex justify-content-center mt-4">
            <Spinner
              animation="border"
              role="status"
              className="d-flex justify-content-center"
            />
          </div>
        ) : data && data.length > 0 ? (
          <>
            <Card className="border-0">
              <Card.Body className="px-1 px-sm-2">
                <CustomTable columns={columns} data={data} />
              </Card.Body>
            </Card>
            <CustomPagint
              limit={limit}
              setLimit={setLimit}
              offset={offset}
              setOffset={handlePagination}
              currentPage={currentPage}
              setCurrentPage={setCurrentPage}
              dataLenght={recidivismActionsDisciplinarias.count}
              pages={pages}
              pagFunc={() => {}}
            />
          </>
        ) : (
          <Alert variant="info" className="my-4">
            Sin registros que mostrar.
          </Alert>
        )}
      </div>
    );
  };

  return (
    <>
      {showComponent ? (
        <ReincidenciasAccionesEmployee
          employeeCode={selectedEmployeeCode}
          employeeName={selectedEmployeeName}
          onClose={() => setShowComponent(false)}
          getRecidivismActions={getRecidivismActionsDisciplinarias}
          toggleButtonsVisibility={toggleButtonsVisibility}
        />
      ) : (
        renderInitialContent()
      )}
    </>
  );
}
export default ReincidenciasAcciones;
